import React, { Component } from 'react'
import {
  UserNav, 
  Button, 
  Generate, 
  Quantity, 
  Localisation, 
  Store,
  Search,
  Arrow,
  Print,
  Edit,
  Valid,
  Field,
  Logo,
} from './../../../components'
import {StockStyle, StockLineStyle} from './../../../styles'
import {addStock} from './../../../services/ApiController'
import {connect} from 'react-redux'
import { withLoader } from '../../../hoc/withLoader'
import {throttle} from 'lodash'

/**
 * TODO: 
 * If user is already update 
 * 
*/


// ROLE
const ROLE = [
  'ROLE_SELLER',
  'ROLE_STORE_MANAGER',
  'ROLE_ZONE_MANAGER',
  'ROLE_MANAGER',
  'ROLE_ADMIN',
  'ROLE_SUPER_ADMIN',
]

const STORE_EDIT = [
  'ROLE_STORE_MANAGER',
  'ROLE_ZONE_MANAGER',
  'ROLE_MANAGER',
  'ROLE_ADMIN',
  'ROLE_SUPER_ADMIN',
]

class Stock extends Component {
  state = {
    load: true,
    references: [],
    store: '',
    error: '',
    store: {},
    first: true,
    stock: [],
    disabled: true,
    search: '',
  }

  componentWillReceiveProps({data}) {
    
    if (data !== this.props.data) {
      
      if (!data.success) {
        this.setState({
          references: data[0].entries,
          store: { label: data[0].label, type: data[0].type, id: data[0].id},
        }, () => {
          this.hasFirstStore()
        })
        
      } else {
        this.setState({ error: data.error })
      }
    }
  }

  initMobileStock = () => {
    const allQuantities = document.querySelectorAll('.stock-line:not(.no-stock) .quantity')
    
    for (const quantity of allQuantities) {
      quantity.style.top = `0`
    }
    
  }

  hasFirstStore = () => {
    // document.querySelector('.stock-table').addEventListener('scroll', this.onScroll)
    
    this.setState({
      first: true
    }, () => {
      this.state.references.map((item) => {
        if (item.quantity > 0 ) this.setState({ first: false})
      })
      this.initMobileStock()
    })
    
  }

  printStock = async () => {
    await window.print()
  }

  sendStock = async () => {
    await addStock(this.state.stock).then((data) => {
      if ( data.success ) {
        this.props.getData(this.props.location, this.props.location.match)
      }

      this.setState({
        disabled: true,
      })
    }).catch((e) => {
      console.log('Oups Something wrong with stock upload', e)
    })
  }

  editStock = async () => {
    await this.setState({ disabled: false })
  }

  updateStock = (qty, id) => {
    const nStock = this.state.stock.filter( stock => stock.referenceId !== id)
    this.setState({
      stock: [
          ...nStock, { 
          id: this.state.store.id,
          referenceId: id,
          quantity: qty
        }]
    })
  }

  addFormData = (data) => {
    this.setState({ search: data.value })
  }

  render () {
    const { references, store, first, disabled, search } = this.state
    const { role, isReady  } = this.props
    return (
      <div className={`${StockStyle(isReady)} stock`} ref={(elt) => this.stockPrint = elt}>
        <UserNav />
        {
          ROLE.indexOf(role) !== -1 ? 
          (
          <div>
            <div className={`transition ${isReady ? 'transition--ready' : ''}`}>
              <div className="stock-filter flex no-print">
                <div className="stock-search">
                  <Field type="text" onChange={this.addFormData}  id='search-model' name='search-model' value='' ><Search width={24} height={24} /> Search by model </Field>
                </div>
                <div className="stock-zone">
                  {
                    store.type === 'store' ? <Store width={40} height={40} /> : <Localisation width={40} height={40} />
                  }
                  <span> {store.label} </span>
                </div>
              </div>
              <div className="print-head only-print">
                <Logo nClass="logo" width="359" height="28" />
                <div className="print-head-title"> Store's stock</div>
              </div>
              {
                references.filter(item => item.model.toLowerCase().match(search.toLowerCase())).length > 0 && (
                  <div className="stock-table" ref={(elt) => this.eltTable = elt}>
                    <div className="head flex">
                      <div className="head-item picture"></div>
                      <div className="head-item ref"> Reference</div>
                      <div className="head-item model"> Model</div>
                      <div className="head-item material"> Case Materials</div>
                      <div className="head-item desc"> Description</div>
                      <div className="head-item price"> Price in Chf </div>
                      <div className="head-item quantity"> Quantity</div>
                    </div>
    
                    <div className="stock-body">
    
                      {
                        references
                        .filter(item => item.model.toLowerCase().match(search.toLowerCase()))
                        .map((item) => (
                          <div className={`${StockLineStyle(item.picture, first, disabled )} ${item.quantity === 0 ? 'no-stock' : ''} stock-line flex`} key={item.referenceId}>
                            <div className="body-item picture"></div>
                            <div className="body-item ref"> {item.reference} </div>
                            <div className="body-item model"> {item.model} </div>
                            <div className="body-item material"> {item.materials} </div>
                            <div className="body-item desc"> {item.description} </div>
                            <div className="body-item price"> {item.price } </div>
                            <div className="body-item quantity">
                              { first || (!first && !disabled) && STORE_EDIT.indexOf(role) !== -1 
                                ? <Quantity updateQty={this.updateStock} id={ item.referenceId } qty={item.quantity} />
                                : <div className="qty-number"> {item.quantity} </div>
                              }
                            </div>
                          </div>
                        ))
                      }
    
                    </div>
                  </div>
                )
              }
            </div>
              
            <div className="stock-button no-print">
              {
                first && (
                  <div>
                    <div className="tooltip flex items-center">
                      <span className="tooltip-label">
                        Click here to generate your store's stock
                      </span>
                      <Arrow width={24} height={24} />
                    </div>
                    {
                      STORE_EDIT.indexOf(role) !== -1 && (
                        <Button type='button' theme='red' className="btn btn-first-stock btn-edit" onCallback={this.sendStock}> 
                          <Generate width={24} height={24} />
                        </Button>
                      )
                    }
                    
                  </div>
                )
              }
              {
                !first && (
                  <div>
                    <div className="tooltip flex items-center">
                        <span className="tooltip-label">
                          Click here to edit or print your store's stock
                        </span>
                        <Arrow width={24} height={24} />
                      </div>
                    <Button type='button' className="btn btn-print" onCallback={this.printStock}> 
                      <Print width={24} height={24} />
                    </Button>
                    {
                      STORE_EDIT.indexOf(role) !== -1 && (
                        disabled ? (
                          <Button type='button' theme='red' className="btn btn-edit" onCallback={this.editStock}> 
                            <Edit width={24} height={24} />
                          </Button>
                        ) : (
                          <Button type='button' theme='red' className="btn btn-edit" onCallback={this.sendStock}> 
                            <Valid width={24} height={24} />
                          </Button>
                        )
                      )
                    }
                  </div>
                )
              }
    
            </div>
          </div>
          )
          : '<p> You are not authorized to view this page. </p>'
        }
      </div>
    )
  }
}


export default withLoader(connect(
  ({ Session }) => ({
    role: Session.role
  })
)(Stock), '/stock')


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Stock.js